import React from "react";
import { Spinner, Container, Tabs, Tab } from "react-bootstrap";
import Header from "../../Common/Header";
import AppliedJobs from "./AppliedJobs/index";
import JobInvites from "./JobInvites/index";
import SuggestedJobs from "./SuggestedJobs/index";
import MainLayout from "../MainLayout";

export default (props) => {
  return (
    <MainLayout pageName={"Jobs"}>
      <div className="bg-grey">
        <Container className="d-flex ">
          <div className="d-flex align-items-center my-3 pb-3 flex-grow-1">
            <h2 className="mr-4 text-nowrap font-weight-medium">
              Candidate Name
            </h2>
          </div>
          <button className="btn btn-primary mb-4">Explore Jobs</button>
        </Container>
      </div>
      <Container className="p-0">
        <div className="hiring-process-dashboard kanban-board-main mt-4">
          <Tabs defaultActiveKey="AppliedJobs" className="my-4  px-3">
            <Tab eventKey="AppliedJobs" title="Applied Jobs">
              <AppliedJobs />
            </Tab>
            <Tab eventKey="JobInvites" title="Job Invites">
              <JobInvites />
            </Tab>
            <Tab eventKey="SuggestedJobs" title="Suggested Jobs">
              <SuggestedJobs />
            </Tab>
          </Tabs>
        </div>
      </Container>
    </MainLayout>
  );
};
